import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '@/../_metronic/layout/MasterLayout'
import { ROUTER_CONSTANTS } from '@/core/constants/common/router-constants';
import { PageLayout } from '@/layout/page-layout'
import InvoiceList from './invoice/invoice-list';
import InvoiceRecording from './invoice/invoice-recording';
import PaymentCalender from './invoice/payment-calender';
import SupplierOrderList from './order-list/supplier-order-list';
import SupplierOrderDetailList from './order-list/supplier-order-detail-list';
import Balance from './invoice/balance';
import WaybillList from './waybill/waybill-list';
import WaybillAdd from './waybill/waybill-add';




const B2bRoutes = () => {

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.SupplierOrderList} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.SupplierOrderList} title="Order List"><SupplierOrderList /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.SupplierOrderDetailList} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.SupplierOrderDetailList} title="Order Detail"><SupplierOrderDetailList /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.InvoiceList} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.InvoiceList} title="Invoice List"><InvoiceList /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.InvoiceRecording} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.InvoiceRecording} title="Invoice Recording"><InvoiceRecording /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.InvoiceDetail} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.InvoiceDetail} title="Invoice Detail"><InvoiceRecording /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.PaymentCalender} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.PaymentCalender} title="Payment Calender"><PaymentCalender /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.Balance} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.Balance} title="Balance"><Balance /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.WaybillList} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.WaybillList} title="Waybill List"><WaybillList /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.WaybillAdd} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.WaybillAdd} title="Waybill Add"><WaybillAdd /></PageLayout>} />
        <Route path={ROUTER_CONSTANTS.SYNCFLOW.WaybillDetail} element={<PageLayout path={ROUTER_CONSTANTS.SYNCFLOW.WaybillDetail} title="Waybill Detail"><WaybillAdd /></PageLayout>} />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}
export default B2bRoutes

